"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialButtonContent = void 0;

var _styles = require("react-components/styles");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Module dependencies.
 */

/**
 * Export `SocialButtonContent` styled component.
 */
var SocialButtonContent = _styledComponents["default"].div.withConfig({
  displayName: "styles__SocialButtonContent",
  componentId: "sc-1wd9blc-0"
})(["align-items:center;display:grid;grid-auto-flow:column;grid-column-gap:", ";justify-content:center;"], (0, _styles.units)(1));

exports.SocialButtonContent = SocialButtonContent;